module.exports = __webpack_public_path__ + "static/media/family-together.41bb2700.png";